import { useKeepAwake } from "expo-keep-awake";

export function KeepAwake() {
  useKeepAwake();
  return null;
}
